/**
 * Reads and validates the `next` query param SignIn/SignUp use to send a
 * visitor back to whatever signed-in-only page they originally asked for
 * (see App.tsx's RedirectToLogin). Restricted to a known internal path
 * rather than "starts with /": `next` rides in a URL a visitor can share or
 * bookmark, and a bare "starts with /" check still lets `//evil.com`
 * through — browsers treat a leading `//` as protocol-relative, so that
 * would send a signed-in visitor off-site instead of into this app.
 */
const KNOWN_PATHS = ['/dashboard', '/keys', '/usage', '/models', '/topup'];

export type SignupAccountType = 'individual' | 'b2b';

export function readNextPath(search: string): string | null {
  const raw = new URLSearchParams(search).get('next');
  return raw && KNOWN_PATHS.includes(raw) ? raw : null;
}

/** Docs/landing cards deep-link signup with ?account_type=individual|b2b. */
export function readSignupAccountType(search: string): SignupAccountType {
  const raw = new URLSearchParams(search).get('account_type');
  return raw === 'b2b' ? 'b2b' : 'individual';
}

export function withNextParam(path: string, search: string): string {
  const params = new URLSearchParams();
  const next = readNextPath(search);
  if (next) params.set('next', next);
  const accountType = new URLSearchParams(search).get('account_type');
  if (accountType === 'b2b' || accountType === 'individual') {
    params.set('account_type', accountType);
  }
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}
